(function (app) {
    app.factory('figPlatformFactory', ['$http', 'permissionService', 'ssoApi', '$q',
        function figPlatformFactory($http, permissionService, ssoApi, $q) {
            var service = {};

            //New logos directory
            var logoPath = 'Images/Dashboard/newPortal/';

            //Anti-purgeCSS since classes are on airtable's server, we keep a copy of all the used classes here
            var antiPurgeCss = [
                'col-span-2 md:col-span-4 lg:col-start-4 lg:col-span-2',
                'md:col-span-2 lg:col-start-4 lg:col-span-1',
                'md:col-span-2 lg:col-span-1',
                'md:col-span-2 lg:col-start-3 lg:col-span-1',
                'md:col-span-2 lg:col-span-1',
                'md:col-span-2 lg:col-span-1',
                'text-blue-dark text-red text-indigo text-green text-pink text-orange-dark',
                'bg-blue-lightest bg-red-lightest bg-indigo-lightest bg-green-lightest bg-pink-lightest bg-orange-lightest',
            ];

            //Airtable base obj, must have url and request headers
            function airTableApi(config) {
                this.BaseUrl = "https://api.airtable.com/v0/app2pNDm4E2zwTdln";
                this.TilesUrl = this.BaseUrl + "/Tiles";
                this.CategoriesUrl = this.BaseUrl + "/Categories";
                this.Config = {
                    headers: {
                        'Authorization': 'Bearer keyMoEilXGyPFGwbX',
                        'Content-Type': 'application/json',
                    },
                    params: config || '',
                }
            }

            //Params use SQL/Excel-esque formula to filter out certain columns & values from table
            service.getAllActiveTiles = function () {
                var params = {
                    filterByFormula: "AND(NOT({Title}=BLANK()),NOT({CategoryName}='Unsorted'),NOT({Active}=BLANK()))"
                }
                var airTable = new airTableApi(params);

                return window.$http.get(airTable.TilesUrl, airTable.Config).then(function (response) {
                    var results = response.data.records;

                    return results.map(function (tile) {
                        var obj = tile.fields;

                        return Object.assign(obj, {
                            AllPermissions: obj.ViewPermission && obj.AccessPermission ? obj.ViewPermission + '|' + obj.AccessPermission : obj.ViewPermission ? obj.ViewPermission : null,
                            LogoUrl: logoPath + obj.Logo,
                        })
                    });
                });
            };

            //Params use SQL/Excel-esque formula to filter out certain columns & values from table
            service.getAllCategories = function () {
                var params = {
                    filterByFormula: "AND(NOT({Name}=BLANK()),NOT({Name}='Unsorted'),NOT({Active}=BLANK()))"
                }
                var airTable = new airTableApi(params);
                return window.$http.get(airTable.CategoriesUrl, airTable.Config).then(function (response) {
                    var results = response.data.records;

                    return results;
                });
            };

            service.getUserPermittedTiles = function () {
                return service.getAllActiveTiles().then(function (response) {
                    var permittedTiles = [];
                    response.forEach(function (tile) {
                        if (!tile.AllPermissions || permissionService.hasAllPermissions(tile.ViewPermission)) {
                            permittedTiles.push(tile);
                        }
                    });
                    return permittedTiles;
                });

            };

            //TODO: Delete when confident
            //var categories = [
            //    {
            //        Id: 0,
            //        Class: 'col-span-2 md:col-span-4 lg:col-start-4 lg:col-span-2',
            //        ColumnCount: 2,
            //        RowCount: 1,
            //        BackgroundImg: 'https://images.unsplash.com/photo-1528029320621-f02197f47774?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=975&q=80',
            //        BackgroundColor: colors.Product.Background,
            //        Color: colors.Product.Forground,
            //        Description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.',
            //        Icon: icons.Product,
            //        Name: 'Product',
            //        Tags: [
            //            {
            //                Name: 'Annuity',
            //                Anchor: null
            //            },
            //            {
            //                Name: 'Life',
            //                Anchor: null
            //            },
            //            {
            //                Name: 'Care Planning',
            //                Anchor: null
            //            },
            //            {
            //                Name: 'Wealth & Estate',
            //                Anchor: null
            //            },
            //            {
            //                Name: 'Structured Products',
            //                Anchor: null
            //            },
            //            {
            //                Name: 'And More',
            //                Anchor: null
            //            },
            //        ]
            //    },
            //    {
            //        Id: 1,
            //        Class: 'md:col-span-2 lg:col-start-4 lg:col-span-1',
            //        ColumnCount: 1,
            //        RowCount: 1,
            //        BackgroundImg: 'https://images.unsplash.com/photo-1453873623425-04e3561289aa?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1666&q=80',
            //        BackgroundColor: colors.IndustryNews.Background,
            //        Color: colors.IndustryNews.Forground,
            //        Description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.',
            //        Icon: icons.IndustryNews,
            //        Name: 'Industry News',
            //    },
            //    {
            //        Id: 2,
            //        Class: 'md:col-span-2 lg:col-span-1',
            //        ColumnCount: 1,
            //        RowCount: 1,
            //        BackgroundImg: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80',
            //        BackgroundColor: colors.RegulatoryAndCompliance.Background,
            //        Color: colors.RegulatoryAndCompliance.Forground,
            //        Description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.',
            //        Icon: icons.RegulatoryAndCompliance,
            //        Name: 'Regulatory &amp; Compliance',
            //    },
            //    {
            //        Id: 3,
            //        Class: 'md:col-span-2 lg:col-start-3 lg:col-span-1',
            //        ColumnCount: 1,
            //        RowCount: 1,
            //        BackgroundImg: 'https://images.unsplash.com/photo-1522204538344-922f76ecc041?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1651&q=80',
            //        BackgroundColor: colors.Marketing.Background,
            //        Color: colors.Marketing.Forground,
            //        Description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.',
            //        Icon: icons.Marketing,
            //        Name: 'Marketing',
            //    },
            //    {
            //        Id: 4,
            //        Class: 'md:col-span-2 lg:col-span-1',
            //        ColumnCount: 1,
            //        RowCount: 1,
            //        BackgroundImg: 'https://images.unsplash.com/photo-1512758017271-d7b84c2113f1?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80',
            //        BackgroundColor: colors.PracticeManagement.Background,
            //        Color: colors.PracticeManagement.Forground,
            //        Description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.',
            //        Icon: icons.PracticeManagement,
            //        Name: 'Practice Management',
            //    },
            //    {
            //        Id: 5,
            //        Class: 'md:col-span-2 lg:col-span-1',
            //        ColumnCount: 1,
            //        RowCount: 1,
            //        BackgroundImg: 'https://images.unsplash.com/photo-1484662020986-75935d2ebc66?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80',
            //        BackgroundColor: colors.Technology.Background,
            //        Color: colors.Technology.Forground,
            //        Description: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod.',
            //        Icon: icons.Technology,
            //        Name: 'Technology',
            //    },
            //];

            //TODO: Delete when confident
            //var tiles = [
            //    {
            //        Active: true,
            //        Category: '',
            //        Description: 'The FIG Symposium is committed to presenting you with the opportunities to learn and to grow both personally and professionally.',
            //        Icon: '',
            //        Id: 'figSymposiumTile',
            //        LogoUrl: logoPath + 'fig-symposium-2021.png',
            //        Permission: 'FigSymposium:View',
            //        SubTitle: '',
            //        Tags: '',
            //        Title: 'FIGSymposium',
            //        Type: '',
            //        Url: 'Home.Resources.FIGSymposium'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'FIG’s digital resource center is here to help you navigate your business in a digital world.',
            //        Icon: '',
            //        Id: 'covidTile',
            //        LogoUrl: logoPath + 'Digital-Marketing-Assets-Logo.png',
            //        //TODO: Update w/ proper permission
            //        Permission: 'Dol:View',
            //        SubTitle: 'How to Manage Your Business Digitally',
            //        Tags: '',
            //        Title: 'Digital Marketing Assets',
            //        Type: '',
            //        Url: 'Home.Resources.Covid19'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Begin including Medicare insurance planning with your clients via our exclusive alliance with MedicareCompareUSA.',
            //        Icon: '',
            //        Id: 'MedicarePlanningTile',
            //        LogoUrl: logoPath + 'Medicare-Planning-Desk-Logo.png',
            //        Permission: 'MedicarePlanning:View',
            //        SubTitle: '',
            //        Tags: '',
            //        Title: 'MedicarePlanning',
            //        Type: '',
            //        Url: 'Home.Resources.MedicarePlanning'
            //    },
            //    //TODO: new table
            //    {
            //        Active: true,
            //        Category: '',
            //        Description: 'Discover the wonders of ancient civilization. Explore a pristine coastline with hidden coves and golden beaches.',
            //        Icon: '',
            //        Id: 'greeceTile',
            //        LogoUrl: logoPath + 'greece-logo-sm.png',
            //        Permission: 'Greece:View',
            //        SubTitle: 'Athens, Greece',
            //        Tags: '',
            //        Title: 'Greece',
            //        Type: '',
            //        Url: 'Home.Resources.Greece'
            //    },
            //    //TODO: new table
            //    {
            //        Active: false,
            //        Category: '',
            //        Description: 'Join FIG’s exclusive escape to Dublin, Ireland!',
            //        Icon: '',
            //        Id: 'irelandTile',
            //        LogoUrl: logoPath + 'dublin-logo.svg',
            //        Permission: 'Greenbrier:View',
            //        SubTitle: ' ',
            //        Tags: '',
            //        Title: 'Ireland',
            //        Type: '',
            //        Url: 'Home.Resources.Ireland'
            //    },
            //    {
            //        Active: true,
            //        Category: '',
            //        Description: 'Elevate offers you exclusive, in-depth training with to the most highly respected experts in the business.',
            //        HideIfOne: 'Elevate:Access',
            //        Icon: icons.Marketing,
            //        Id: 'elevateTile',
            //        LogoUrl: logoPath + 'elevate-logo.svg',
            //        Permission: 'Elevate:View',
            //        SubTitle: 'Elevate',
            //        Tags: '',
            //        Title: 'Elevate',
            //        Type: 'platform',
            //        Url: 'Home.Tools.MarketPlace.Elevate'
            //    },
            //    //TODO: new table
            //    {
            //        Active: true,
            //        Category: '',
            //        Description: 'All Points Media also offers simple solutions and affordable services to streamline your business and keep the momentum going.',
            //        HideIfOne: 'CreativeServices:Access|Elevate:Access',
            //        Icon: '',
            //        Id: 'creativeTile',
            //        LogoUrl: logoPath + 'creative-services-logo.png',
            //        Permission: 'CreativeServices:View',
            //        SubTitle: 'Creative Services',
            //        Tags: '',
            //        Title: 'Creative Services',
            //        Type: '',
            //        Url: 'Home.Tools.MarketPlace.CreativeServices'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Specialized Marketing Strategies',
            //        HideIfOne: 'ElevateForLife:Access',
            //        Icon: '',
            //        Id: 'elevateLifeTile',
            //        LogoUrl: logoPath + 'e4l-logo.svg',
            //        Permission: 'ElevateForLife:View',
            //        SubTitle: 'Elevate For Life',
            //        Tags: '',
            //        Title: 'Elevate For Life',
            //        Type: '',
            //        Url: 'Home.Tools.MarketPlace.ElevateLife'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Force CRM is more than your typical CRM. Designed to connect all aspects of your business with minimal effort from the advisor.',
            //        Icon: '',
            //        Id: 'ForceCRM',
            //        LogoUrl: logoPath + 'force-crm-logo.svg',
            //        Permission: 'ForceCRM:View',
            //        SubTitle: 'ForceCRM',
            //        Tags: '',
            //        Title: 'ForceCRM',
            //        Type: '',
            //        Url: 'Home.Resources.ForceCRM'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'iComply is a powerful online tool for compliance suitability and fiduciary responsibilities, electronic application, and document management.',
            //        Icon: '',
            //        Id: 'iComply',
            //        LogoUrl: logoPath + 'icomply-logo.svg',
            //        Permission: 'IComply:View',
            //        SubTitle: 'iComply',
            //        Tags: '',
            //        Title: 'iComply',
            //        Type: '',
            //        Url: 'Home.Resources.iComply'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Personalized Care Planning tools and content offered through Active Daily Living ',
            //        Icon: '',
            //        Id: 'ActiveDailyLiving',
            //        LogoUrl: logoPath + 'ADL-logo.svg',
            //        Permission: 'ActiveDailyLiving:View',
            //        SubTitle: 'Active Daily Living',
            //        Tags: '',
            //        Title: 'Active Daily Living',
            //        Type: '',
            //        Url: 'Home.Resources.ActiveDailyLiving'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Empower your advisors to guide their clients through a personalized retirement planning experience.',
            //        Icon: '',
            //        Id: 'RetireUp',
            //        LogoUrl: logoPath + 'retire-up-pro-logo.svg',
            //        Permission: 'RetireUp:View',
            //        SubTitle: 'RetireUp',
            //        Tags: '',
            //        Title: 'RetireUp',
            //        Type: '',
            //        Url: 'Home.Resources.RetireUp'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Streamline processes and get your business on a track to continued profitability.',
            //        Icon: '',
            //        Id: 'surgeTile',
            //        LogoUrl: logoPath + 'surge-logo.svg',
            //        Permission: 'Surge:View',
            //        SubTitle: 'Reach those business goals',
            //        Tags: '',
            //        Title: 'Surge',
            //        Type: '',
            //        Url: 'Home.Resources.Surge'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Let us guide you through the process to securing your succession planning strategy.',
            //        Icon: '',
            //        Id: 'nextTile',
            //        LogoUrl: logoPath + 'next-logo.svg',
            //        Permission: 'Next:View',
            //        SubTitle: 'Are you ready to take the next step?',
            //        Tags: '',
            //        Title: 'Next',
            //        Type: '',
            //        Url: 'Home.Resources.Next'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Access to Tip of the Triangle provides benefits that allow you to interact with other top level producers with FIG.',
            //        Icon: '',
            //        Id: 'totTile',
            //        LogoUrl: logoPath + 'TOT-logo-sm.png',
            //        Permission: 'TipOfTheTriangle:View|TipOfTheTriangle:Access',
            //        SubTitle: 'Tip of the Triangle',
            //        Tags: '',
            //        Title: 'Tip of the Triangle',
            //        Type: '',
            //        Url: 'Home.Resources.TOT'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Ensuring the Right Fit for your Needs.',
            //        Icon: '',
            //        Id: 'talentSolutionsTile',
            //        LogoUrl: logoPath + 'talent-solutions-logo.svg',
            //        Permission: 'FigTalentSolutions:View',
            //        SubTitle: 'Improve your skills',
            //        Tags: '',
            //        Title: 'FIG Talent Solutions',
            //        Type: '',
            //        Url: 'Home.Resources.TalentSolutions'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Join the Power of Zero Marketing Revolution.  Never worry about prospecting again.',
            //        Icon: '',
            //        Id: 'pozTile',
            //        LogoUrl: logoPath + 'poz-logo.png',
            //        Permission: 'PowerOfZeroPlus:View',
            //        SubTitle: 'Power of Zero',
            //        Tags: '',
            //        Title: 'Power of Zero',
            //        Type: '',
            //        Url: 'Home.Resources.PowerOfZero'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Get Started Building Business Retirement Plan Reviews.',
            //        Icon: '',
            //        Id: 'millenniumTile',
            //        LogoUrl: logoPath + 'millenium-logo.svg',
            //        Permission: 'Millennium:View',
            //        SubTitle: 'Millennium',
            //        Tags: '',
            //        Title: 'Millennium',
            //        Type: '',
            //        Url: 'Home.Resources.Millennium'
            //    }, {
            //        Active: false,
            //        Category: '',
            //        Description: 'Providing accurate, unbiased, and up-to-date retirement education through college-style courses and classes nationwide.',
            //        Icon: '',
            //        Id: 'prepareTile',
            //        LogoUrl: logoPath + 'prepare-logo.png',
            //        Permission: 'Prepare:View',
            //        SubTitle: 'Prepare',
            //        Tags: '',
            //        Title: 'Prepare',
            //        Type: '',
            //        Url: 'Home.Resources.Prepare'
            //    }, {
            //        Active: false,
            //        Category: '',
            //        Description: 'Boutique Marketing for Financial Advisors',
            //        Icon: '',
            //        Id: 'megTile',
            //        LogoUrl: logoPath + 'meg-logo.png',
            //        Permission: 'MarkGaffney:View',
            //        SubTitle: 'Mark Edward Gaffney',
            //        Tags: '',
            //        Title: 'Mark Edward Gaffney',
            //        Type: '',
            //        Url: 'Home.Resources.MEG'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'A Full-Service Sales & Marketing Company for Financial Advisors',
            //        Icon: '',
            //        Id: 'loneBeaconTile',
            //        LogoUrl: logoPath + 'LoneBeacon-logo.png',
            //        Permission: 'LoneBeacon:View',
            //        SubTitle: 'LoneBeacon',
            //        Tags: '',
            //        Title: 'LoneBeacon',
            //        Type: '',
            //        Url: 'Home.Resources.LoneBeacon'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'E&O Coverage - Lockton Affinity',
            //        Icon: '',
            //        Id: 'locktonTile',
            //        LogoUrl: logoPath + 'lockton-logo.png',
            //        Permission: 'Lockton:View',
            //        SubTitle: 'Lockton',
            //        Tags: '',
            //        Title: 'Lockton',
            //        Type: '',
            //        Url: 'Home.Resources.Lockton'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Your exclusive access to THE Retirement Income Expert, Tom Hegna!',
            //        Icon: '',
            //        Id: 'Hegna',
            //        LogoUrl: logoPath + 'rhn-logo.png',
            //        Permission: 'HegnaRHN:View',
            //        SubTitle: '',
            //        Tags: '',
            //        Title: 'Retire Happy Now',
            //        Type: '',
            //        Url: 'Home.Resources.Hegna'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Is your mind spinning with all things regulatory? Let FIG help you navigate your business through changes.',
            //        Icon: '',
            //        Id: 'dolTile',
            //        LogoUrl: logoPath + 'industry-regs-logo-d.png',
            //        Permission: 'Dol:View',
            //        SubTitle: 'Continued learning on the DOL rule',
            //        Tags: '',
            //        Title: 'Industry Regulations & Updates',
            //        Type: '',
            //        Url: 'Home.Resources.DOL'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Gain the knowledge to educate your potential clients on the future of Social Security.',
            //        Icon: '',
            //        Id: 'ssrTile',
            //        LogoUrl: logoPath + 'ssr-logo.svg',
            //        Permission: 'SocialSecurityResources:View',
            //        SubTitle: 'Social Security Resources',
            //        Tags: '',
            //        Title: 'Social Security Resources',
            //        Type: '',
            //        Url: 'Home.Resources.SSR'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'The CAR policy review can enhance the relationship with your client/prospect.',
            //        Icon: '',
            //        Id: 'carTile',
            //        LogoUrl: logoPath + 'car-logo.svg',
            //        Permission: 'Car:View',
            //        SubTitle: 'CAR Program',
            //        Tags: '',
            //        Title: 'CAR Program',
            //        Type: '',
            //        Url: ''
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Open the possibilities for your marketing strategies and systems.',
            //        Icon: '',
            //        Id: 'salesCoachWOOTile',
            //        LogoUrl: logoPath + 'salescoach-woo-logo-d.svg',
            //        Permission: 'SalesCoachWindowsOfOpportunity:View',
            //        SubTitle: 'Improve your skills',
            //        Tags: '',
            //        Title: 'Sales Coach: Windows of Opportunity',
            //        Type: '',
            //        Url: 'Home.Resources.SalesCoachWOO'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Video seminars and presentations to expand your knowledge.',
            //        Icon: '',
            //        Id: 'ltcTrainingTile',
            //        LogoUrl: logoPath + 'care-planning-resources-logo.svg',
            //        Permission: 'LtcTraining:View',
            //        SubTitle: 'Care Planning',
            //        Tags: '',
            //        Title: 'Care Planning Resources',
            //        Type: '',
            //        Url: 'Home.Resources.LTCTraining'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Leverage one of the market’s important Life Insurance products with the complete turn-key IUL Solutions Program.',
            //        Icon: '',
            //        Id: 'iulTile',
            //        LogoUrl: logoPath + 'iul-logo.svg',
            //        Permission: 'IulComplete:View',
            //        SubTitle: 'IUL Complete',
            //        Tags: '',
            //        Title: 'IUL Complete',
            //        Type: '',
            //        Url: 'Home.Resources.IUL'
            //    }, {
            //        Active: false,
            //        Category: '',
            //        Description: 'Join FIG’s exclusive escape to the Greenbrier resort!',
            //        Icon: '',
            //        Id: 'greenbrierTile',
            //        LogoUrl: logoPath + 'greenbrier-logo.png',
            //        Permission: 'Greenbrier:View',
            //        SubTitle: ' ',
            //        Tags: '',
            //        Title: 'Greenbrier',
            //        Type: '',
            //        Url: 'Home.Resources.Greenbrier'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Schechter Wealth wants to send you on an all-expense paid trip to Mexico!!',
            //        Icon: '',
            //        Id: 'puntaMitaTile',
            //        LogoUrl: logoPath + 'punta-mita-logo.png',
            //        Permission: 'PuntaMita:View',
            //        SubTitle: 'Advisor Sales Contest – Inviting all FIG Advisors to Participate',
            //        Tags: '',
            //        Title: 'PuntaMita',
            //        Type: '',
            //        Url: 'Home.Resources.PuntaMita'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Practical professional education, delivered by the nation’s only accredited nonprofit dedicated to the financial services profession.',
            //        Icon: '',
            //        Id: 'tacTile',
            //        LogoUrl: logoPath + 'american-college-logo.png',
            //        Permission: 'AmericanCollege:View',
            //        SubTitle: '',
            //        Tags: '',
            //        Title: 'The American College',
            //        Type: '',
            //        Url: 'Home.Resources.TheAmericanCollege'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'Log into our instance of Office Depot’s website to take full advantage of all the great savings at Office Depot!',
            //        Icon: '',
            //        Id: 'officeDepotTile',
            //        LogoUrl: logoPath + 'od-omax-logo.svg',
            //        Permission: 'OfficeDepot:View',
            //        SubTitle: '',
            //        Tags: '',
            //        Title: 'Office Depot',
            //        Type: '',
            //        Url: 'Home.Resources.OfficeDepot'
            //    }, {
            //        Active: true,
            //        Category: '',
            //        Description: 'View requirements regarding carrier specific and state annuity training.',
            //        Icon: '',
            //        Id: 'trainingTile',
            //        LogoUrl: logoPath + 'training-logo-sm.png',
            //        Permission: 'FigTraining:View',
            //        SubTitle: '',
            //        Tags: '',
            //        Title: 'FIG Carrier Specific & State Annuity Training',
            //        Type: '',
            //        Url: 'Home.Resources.FIGTraining'
            //    }];

            return service;
        }]);
})(window.app);